import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import type { RoleDto } from "@/api/types/dtos/role-privilege.dto";

interface ChangeRoleDialogProps {
  open: boolean;
  userName: string;
  orgName: string;
  roles: RoleDto[];
  loading: boolean;
  submitting: boolean;
  selectedRole: RoleDto | null;
  onRoleChange: (role: RoleDto | null) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

const ChangeRoleDialog: React.FC<ChangeRoleDialogProps> = ({
  open,
  userName,
  orgName,
  roles,
  loading,
  submitting,
  selectedRole,
  onRoleChange,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      aria-labelledby="change-role-dialog-title"
      aria-modal="true"
    >
      <DialogTitle id="change-role-dialog-title">Añadir Rol</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Asignar rol a <strong>{userName}</strong> en <strong>{orgName}</strong>
        </Typography>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <Autocomplete
            options={roles}
            getOptionLabel={(option) => option.name || ""}
            value={selectedRole}
            onChange={(_, value) => onRoleChange(value)}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField {...params} label="Rol" placeholder="Seleccionar rol..." />
            )}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={submitting}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={!selectedRole || submitting}
          startIcon={submitting ? <CircularProgress size={16} /> : undefined}
        >
          {submitting ? "Guardando..." : "Asignar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeRoleDialog;
